import React, { useState } from 'react'
import SliderWrapper from 'jd-library/SliderWrapper'
import ListItem from 'jd-library/ListItem'
import { connect } from 'react-redux'
import historyHandler from 'jd-library/historyHandler'
import styles from './copy-images.scss'
import ImageIcons from 'jd-library/ImageIcons';
import {useSelector, shallowEqual} from 'react-redux';
import { toggleCopySlider } from '../../../actions/upload-options'; 

const CopyImagesSlider = (props) => {

    const getSliderOptions = ({uploadOptions}) => uploadOptions;
    const [selectedList, setSelectedList] = useState([])
    const [imagesPresent, setImagesPresent] = useState(false);

    const options = useSelector(getSliderOptions, shallowEqual);
    let {
        imageUrlArr,
        onSave,
        showToastMessage,
        variantIndex,
        variantProductData
    } = options.data

    let variantProducts = variantProductData?variantProductData:props.variantProducts;
    
    const selectItem = (index) => {
        if(selectedList.indexOf(index) == -1){
            setSelectedList([...selectedList,index]);
        }else{
            let temp = [...selectedList];
            temp.splice(temp.indexOf(index),1);
            setSelectedList(temp)
        }
    }

    const getMiddleSection = (product) => {
        let markup = [];
        for(let i=0;i<Math.min(product.imageUrlArr.length, 4);i++){
            markup.push(
                <div className={styles['image-holder']}>
                    <img src={product.imageUrlArr[i].actualPath} />
                    {
                        (product.imageUrlArr.length>4 && i==3) ? 
                            <div className={styles['count-holder']}>
                                + {(product.imageUrlArr.length - 4)}
                            </div> : 
                            <></>
                    }
                </div>
            )
        }
        if(!imagesPresent){
            setImagesPresent(true);
        }
        return markup;  
    }

    const getVariantTitle = (arr) => {
        let str = [];
        for(let i=0;i<arr.length;i++){
            str.push(<span className={styles['variant-type-info']}>
                <span className={styles['variant-type']}>{Object.keys(arr[i])[0]}</span>: <span className={styles['variant-option']}>{arr[i][Object.keys(arr[i])[0]]}</span>{i==arr.length-1 ? "" : <span className={styles['vertical-divider']}> | </span>}
            </span>)
        }
        return str;
    }

    return options.sliderType == 'copy' && (
        <SliderWrapper 
            header={{
                heading: 'Copy Image',
                rightIcons: props.isMobile ? [] : [
					{
						className: 'icon-HDRcross',
						onClick: e => {
                            const openSliders = historyHandler.getOpenSliders();
                            historyHandler.closeMultiSlider(openSliders.length-1);
						}
					}
				]
            }}
            animateChildren={false}
            slider={{className: styles['copy-images']}}
            onHidden={() => props.toggleCopySlider({show: false})}
            footer={imagesPresent ? {
                btnProps: [{
                    children: 'Continue',
                    clickHandler: () => {
                        let images = []; 
                        selectedList.map((item)=>{
                            images.push(...variantProducts[item].imageUrlArr)
                        })
                        if(imageUrlArr?.length + images.length > 40){
                            showToastMessage({
                                message: 'Max 40 Images can be Uploaded',
                                type: 'info'
                            })
                            let remaincount = 40 - imageUrlArr?.length;
                            if(remaincount){
                                images = images.slice(0,remaincount);
                                onSave && onSave(images);
                            }
                        }else{
                            onSave && onSave(images);
                            setSelectedList([]);
                        }
                        historyHandler.closeCurrent();
                    }
                }]
            } : null}
        >
            <div>
                {
                    variantProducts.map((product, index)=>{
                        if(product.imageUrlArr.length && index!=variantIndex){
                            const isSelected = selectedList.indexOf(index) != -1;
                            return(
                                <ListItem 
                                    selectable={true}
                                    selected={isSelected}
                                    toggleSelected={()=>selectItem(index)}
                                    onClick={()=>selectItem(index)}
                                    enableLongPress={true}
                                    showCheckBox={true}
                                    middleSection={
                                        <>
                                            <div>{getVariantTitle(props.variantCombinations[index])}</div>
                                            <div className={styles['images-holder']}>
                                                {getMiddleSection(product)}
                                            </div>
                                        </>
                                    }
                                    checkboxTopAligned={true}
                                    className={`${props.listClass ? props.listClass : ''} ${isSelected ? styles['bg-selected'] : ''}`}
                                />
                            )
                        }else{
                            return <></>
                        }
                    })
                }
                {!imagesPresent && <div className={styles['no-images-holder']}>
                    <img src={ImageIcons.NO_SEARCH} />
                    No Images Found
                </div>}
            </div>
        </SliderWrapper>
    )
}

const mapStateToProps = (state, props) => {
    return{
        ...props,
        isMobile: state.deviceData.isMobile,
        variantProducts: state.variants.variantProductData,
        variantCombinations: state.variants.variantCombinations
    }
}

export default connect(mapStateToProps,{toggleCopySlider})(CopyImagesSlider)